import React from "react";

export const ContactBtn = ({ label }) => {
  return (
    <a
      href="https://wa.me/+917566611125/?text=Hello Kalka Capital"
      className="inline-block bg-white text-red-500 font-semibold py-3 px-8 rounded-lg hover:bg-transparent hover:border hover:border-white border border-white hover:text-white hover:text-matt-red-300 transition duration-300"
    >
      {label}
    </a>
  );
};
